import { Controller } from "@hotwired/stimulus"

// Manages toast notification auto-dismiss and close behavior.
//
// Automatically dismisses after 5 seconds with a fade-out transition.
// Users can manually close via the close button.
export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => this.dismiss(), 5000)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  close() {
    this.dismiss()
  }

  dismiss() {
    if (this.timeout) clearTimeout(this.timeout)
    this.element.classList.add("opacity-0", "transition-opacity", "duration-300")
    setTimeout(() => this.element.remove(), 300)
  }
}
